import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar";
import { AppTitle } from "./AppTitle";
import { NavGroup } from "./NavGroup";
import { AppUser } from "./AppUser";
import { useApplicationContext } from "@/context/ApplicationContext";
import { SearchEverywhereTrigger } from "../searchEverywhere/SearchEverywhereTrigger";

export function AppSidebar() {
  const { availableSidebarNavigationOptions } = useApplicationContext();

  return (
    <Sidebar collapsible="icon" variant="sidebar">
      <SidebarHeader>
        <AppTitle />
      </SidebarHeader>
      <SidebarContent>
        <SearchEverywhereTrigger />
        {availableSidebarNavigationOptions.map((props) => (
          <NavGroup key={props.title} {...props} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <AppUser />
      </SidebarFooter>
    </Sidebar>
  );
}
